export default __webpack_public_path__ + "static/media/LandingPage_.62119905.png";